export default __webpack_public_path__ + "static/media/bw.94a7d0c6.jpg";